import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'
import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { Course } from './course'
import { courseActions } from './course.actions'
import * as fromCourse from './course.reducer'
import { CourseService } from './course.service'
import { take, tap } from 'rxjs/operators'
import { persistentUserRoleActions } from '../role/user-role/persistent-user-role/persistent-user-role.actions'
import { persistentUserRoleSelectors } from '../role/user-role/persistent-user-role/persistent-user-role.selector'
import { UserRole } from '../role/user-role/user-role'

@Injectable()
export class CourseEffects extends ResourceEffects<Course> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public courseService: CourseService
  ) {
    super(fromCourse.FEATURE_NAME, courseService, courseActions, actions$)
  }

  onSetSelectedUserRole = createEffect(
    () =>
      this.actions$.pipe(
        ofType(persistentUserRoleActions.setSelectedUserRole),
        tap((action) => {
          let userRole: any
          this.store
            .select(persistentUserRoleSelectors.selectSelectedUserRole)
            .pipe(take(1))
            .subscribe((userRole: UserRole) => {
              userRole = userRole
            })
          userRole && this.store.dispatch(courseActions.resetState())
        })
      ),
    { dispatch: false }
  )
}
